var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGatsbyCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.001.608C6.991.608.608 6.991.608 15S6.991 29.394 15 29.394s14.393-6.383 14.393-14.393S23.01.608 15 .608zM3.737 15.126l11.14 11.14c-6.134 0-11.14-5.007-11.14-11.14zm13.767 10.889L3.988 12.498C5.112 7.492 9.619 3.737 15 3.737a11.371 11.371 0 019.137 4.632L22.51 9.744a9.189 9.189 0 00-7.635-4.004 9.066 9.066 0 00-8.636 6.132l11.765 11.766c2.88-1.002 5.131-3.504 5.757-6.51h-4.881v-2.127h7.385c0 5.382-3.755 9.888-8.762 11.014z",
    fill: "#fff"
  })));
}

export default SvgGatsbyCloud;